/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
import { type UFOGlobalEventStreamEvent } from '../types';

export type GlobalEventStream = {
	__buffer_only__: boolean;
	push(event: UFOGlobalEventStreamEvent): void;
};

export const MAX_EARLY_QUEUE_LENGTH = 250;

declare global {
	var __UFO_GLOBAL_EVENT_STREAM__: any;
}
/**
 * @deprecated Use `import { getGlobalEventStream } from '@atlassian/ufo-experimental'` instead.
 */
export { getGlobalEventStream } from './getGlobalEventStream';
/**
 * @deprecated Use `import { setGlobalEventStream } from '@atlassian/ufo-experimental'` instead.
 */
export { setGlobalEventStream } from './setGlobalEventStream';
/**
 * @deprecated Use `import { subscribeEvent } from '@atlassian/ufo-experimental'` instead.
 */
export { subscribeEvent } from './subscribeEvent';
/**
 * @deprecated Use `import { unsubscribeEvent } from '@atlassian/ufo-experimental'` instead.
 */
export { unsubscribeEvent } from './unsubscribeEvent';
/**
 * @deprecated Use `import { experiencePayloadEvent } from '@atlassian/ufo-experimental'` instead.
 */
export { experiencePayloadEvent } from './experiencePayloadEvent';
